(function ($, Drupal) {
  'use strict';
  Drupal.behaviors.dlaLazyload = {
    attach: function attach(context, settings) {

      // Initialise lazy load object
      var myLazyLoad = new LazyLoad();
      // $(context).find('.dla-image-container, .dla-hero-image-container').once().each(function () {
      $(context).find('img').each(function () {
        myLazyLoad.update();
      });

    }
  };

})(jQuery, Drupal);
